/**
 * Resolve o identificador do dependente (ex.: username/ehrrunner) de forma robusta.
 *
 * Contexto do legado:
 * - Em alguns fluxos, o "dependente" chega como um Patient-like com `identifier` no formato FHIR (array de Identifier).
 * - Em outros (ex.: `useRelatedPersons`), o campo `identifier` é sobrescrito como `string` (id do Patient),
 *   normalmente no formato "<prefixo>-<valor>".
 *
 * Regra pedida:
 * - Preferir `identifier.split('-')?.[1]` (quando `identifier` for string).
 * - Usar `dependente?.identifier?.[0]?.value` apenas como fallback.
 *
 * Importante:
 * - Se o split não produzir um valor válido, não forçamos "adivinhações" (mantemos fallback).
 */
export function getDependentIdentifier(dependente: any): string | undefined {
  const identifierRaw =
    typeof dependente?.identifier === "string" ? dependente.identifier : undefined;

  const parsedFromRaw = identifierRaw?.split("-")?.[1];
  if (typeof parsedFromRaw === "string" && parsedFromRaw.trim()) {
    return parsedFromRaw.trim();
  }

  const fallbackFromFhir = dependente?.identifier?.[0]?.value;
  if (typeof fallbackFromFhir === "string" && fallbackFromFhir.trim()) {
    return fallbackFromFhir.trim();
  }

  return undefined;
}

